module.exports = __webpack_public_path__ + "media/night/377-f98d7d49.svg";